import { MatDialogModule } from '@angular/material/dialog';
import { FuseSharedModule } from '@fuse/shared.module';
import { CriticalRequestComponent } from './critical-request/critical-request.component';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CountdownModule } from 'ngx-countdown';
import { MetaService } from '../../../../shared/cw-backend/providers/system/meta/meta.service';
import { ModalDefaultersComponent } from './modal-defaulters/modal-defaulters.component';
import { ModalComponent } from './modal.component';

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        MatToolbarModule,
        MatDialogModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatDialogModule,
        CountdownModule,
        FuseSharedModule

    ],
    declarations: [
        ModalComponent,
        CriticalRequestComponent,
        ModalDefaultersComponent
    ],
    exports: [
        ModalComponent,
        CriticalRequestComponent,
        ModalDefaultersComponent,
        MatIconModule,
        MatToolbarModule,
        MatDialogModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatDialogModule,
        FuseSharedModule,

    ], providers: [
        MetaService
    ]
})
export class ModalModule { }